import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Result } from '../models/result';
import { getAppUpdate, openHelpChatInWhatsapp } from '../repositories/generalRepo';
import Logger from '../utils/logger';

const generalStore = create(persist(
    (set, get)=>({
        currentAppVersion: '1.0.41',
        latestAppVersion: null,
        checkingUpdate: false,
        checkUpdateError: null,
        hasUpdate: false,

        checkUpdate: async ()=>{
            set({checkingUpdate: true, checkUpdateError: null});
            const result = await getAppUpdate();
            if(result.success){
                const latestVersion = result.value.latestVersion;
                Logger.info(`Latest version: ${latestVersion} | current version: ${get().currentAppVersion}`);
                if(get().currentAppVersion != latestVersion){
                    set({hasUpdate: true, latestAppVersion: latestVersion});
                }
            }else{
                set({checkUpdateError: result});
            }
            set({checkingUpdate: false});
        },

        
        openHelpChatInWhatsapp: async (phoneNumber)=>{
            console.log('openHelpChatInWhatsapp');
            const result = await openHelpChatInWhatsapp(phoneNumber);
        },

    }),
{
    name: 'general-store',
    partialize: (state)=>({
    }),
}),
)

export default generalStore;